<template>
  <div class="auth" id="auth" name="auth">
    <div class="top">
      <NavTop activeIndex="3"></NavTop>
    </div>
    <div class="" style="
        height: 666px;
        border: 1px solid #000;
        background-color: #25284c;
        padding-top: 10px;
        margin-top: 70px;
      ">
      <div class="" style="
          width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          height: 648px;
          border-radius: 8px 8px 0 0;
        ">
        <div class="" style="
            width: 860px;
            background-color: #fff;
            height: 648px;
            margin-right: 10px;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          ">
          <div class="" style="
              width: 100%;
              height: 100px;
              display: flex;
              justify-content: space-between;
              border-radius: 8px 8px 0 0;
            ">
            <div class="" style="display: flex; align-items: center">
              <img :src="baseUrl + liveDEtail.user.avatar" alt="" style="
                  width: 60px;
                  height: 60px;
                  border-radius: 50%;
                  display: block;
                  margin-right: 10px;
                  margin-left: 10px;
                " />
              <div class="">
                <div class="" style="font-weight: bold; margin-bottom: 5px; font-size: 18px">
                  {{ liveDEtail.title }}
                </div>
                <div class="" style="display: flex; align-items: center">
                  <div class="text-ellipsis-2"
                    style="color: #666; margin-right: 10px;word-wrap: break-word;max-width: 450px;">
                    {{ liveDEtail.user.nickname }}
                  </div>
                  <div class="" style="color: #666; margin-right: 10px">
                    房间号:{{ liveDEtail.room_id }}
                  </div>
                  <img src="../assets/images/fire.png" alt="" style="width: 12px; height: 12px; margin-right: 2px" />
                  <div class="" style="color: #666; margin-right: 10px">
                    {{ liveDEtail.heat }}
                  </div>
                  <!-- <div class="" style="color: #666; margin-right: 10px">
                    观看人数: {{ liveDEtail.viewers }}
                  </div> -->

                  <!-- <div class="" style="color: #666;">下载APP可投屏电视</div> -->
                </div>
              </div>
            </div>
            <div class="" style="display: flex; align-items: center;margin-right: 30px;">
              <div class="" style="
                  border-radius: 60px;
                  padding: 5px 20px;
                  background-color: #4b72f6;
                  color: #fff;
                  font-size: 16px;
                  cursor: pointer;
                " @click="gaunhzu" v-if="liveDEtail.is_follow == 0">
                关注
              </div>
              <div class="" style="
                  border-radius: 60px;
                  padding: 5px 20px;
                  background-color: #eee;
                  color: #fff;
                  font-size: 16px;
                  cursor: pointer;
                " @click="qxgaunhzu" v-if="liveDEtail.is_follow == 1">
                已关注
              </div>


              <!-- <div class="" style="width: 24px;height: 24px;margin-left: 24px;position: relative;">
                <img src="https://sta03.sxzhjt.cn/web/assets/yy/img/icon-room-code.png" alt=""
                  style="width: 24px;height: 24px;" @mouseenter="showTips = true" @mouseleave="showTips = false">
                <div class="notice-box" v-if="showTips">
                  <img src="../assets/imgs/goods.png" alt=""
                    style="width: 90px;height: 90px;margin: 30px auto 20px;display: block;">
                  <div class="" style="text-align: center;">
                    用手机浏览器扫一扫
                  </div>
                  <div class="" style="text-align: center;">
                    精彩内容马上呈现
                  </div>
                </div>
              </div> -->
              <!-- <div class="" @mouseenter="showTips1 = true" @mouseleave="showTips1 = false" style="position: relative">
                <i class="el-icon-arrow-down" style="margin: 0 20px; font-size: 20px"></i>
                <div class="" style="
                    background-color: #fff;
                    padding: 10px;
                    box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.2);
                    border-radius: 2px;
                    position: absolute;
                    left: 20px;
                    top: 20px;
                    width: 80px;
                    cursor: pointer;
                  " v-if="showTips1">
                  举报
                </div>
              </div> -->
            </div>
          </div>
          <div class="" style="
              background-color: #25284c;
              flex: 1;
              display: flex;
              flex-direction: column;
            ">

            <div class="" style="width: 860px">
              <div id="" style="position: relative">
                <liveTv :islive="liveDEtail.status" path="live" :reserve="reserve" :info="detail" ref="livetv"
                  :aotoPl="aotoPl" @changRoom="changRoom">
                </liveTv>
                <div class="" style="position: absolute;top: 0;left: 0;width: 860px;height: 500px;z-index: 6;"
                  v-if="showGift">
                  <!-- <svgaplayer src="https://mp-eeab6da6-80cd-4e80-844a-66b2a7203834.cdn.bspapp.com/cloudstorage/b3875bda-8de0-476d-8f55-d10b24f16d98.svg"> </svgaplayer> -->
                  <svgaplayer :src="svgSrc" style="width: 860px;height: 500px;"> </svgaplayer>

                </div>
              </div>
            </div>
          </div>
          <div class="" style="
              background-color: #fff;
              height: 64px;
              border-radius: 0 0 8px 8px;
              display: flex;
              padding: 0 20px;
            ">
            <div class="" style="width: 150px; border-right: 1px solid #eee">
              <div class="" style="font-size: 24px">{{ userInfo.money || 0 }}</div>
              <div class="" style="font-size: 12px">我的金币</div>
            </div>
            <div class="" style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex: 1;
              ">
              <div class="" style="display: flex; align-items: center;width: 500px;overflow-y: scroll;">
                <!-- <div class="" v-for="(item, index) in gifList" :key="index" @click="songli(item)"
                  style="position: relative;z-index: 99;" >
                  <img :src="item.icon_text" alt="" style="width: 44px; height: 44px; margin-left: 30px;z-index: 99;"  @mouseenter="showgist = index" @mouseleave="showgist = -1"/>
                  <div class="" style="
                      background-color: #fff;
                      padding: 10px;
                      position: absolute;
                      top: -60px;
                      left: 0;
                      width: 100px;
                      border-radius: 5px;
                      color: #4b72f6;
                      text-align: center;
                    " v-if="showgist == index">
                    {{ item.price }}金币
                  </div>
                </div> -->
                <div class="" v-for="(item, index) in gifList" :key="index" @click="songli(item)">
                  <el-popover placement="top" trigger="hover">
                    <div class="">
                      <div class="" style="text-align: center;color: #4b72f6;">
                        {{ item.name }}
                      </div>
                      <div class="" style="text-align: center;">
                        {{ item.price }}金币
                      </div>
                    </div>
                    <div slot="reference">
                      <img :src="item.icon_text" alt=""
                        style="width: 44px; height: 44px; margin-left: 30px;z-index: 99;" />
                    </div>
                  </el-popover>

                </div>
              </div>
              <div class="" style="color: #777; cursor: pointer" @click="digShow = true">
                如何获取金币?
              </div>
            </div>
          </div>
        </div>
        <div class="" style="
            background-color: #fff;
            height: 648px;
            width: 320px;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
          ">
          <div class="gogngaoBox" style="
              display: flex;
              padding: 10px;
              box-sizing: border-box;
              height: 64px;
              border-bottom: 1px solid #eee;
              overflow: hidden;
            ">
            <img src="../assets/images/icon-announcement@2x.png" alt="" style="
                width: 20px;
                height: 20px;
                display: block;
                margin-right: 3px;
              " />
            <div class="" style="flex-shrink: 0">公告:</div>
            <div class="" style="color: #777;word-wrap: break-word;width: 250px;">
              {{ liveDEtail.notice }}
              <!-- 因为热爱 所以专业 深度干货分析解盘.
              对临场数据变化极为敏锐，熟悉机构所有操盘套路，对于冷门比赛数据有深刻洞察和理解，对比赛进球数判断尤为精准。想和主播一起集思广益，点点关注。 -->


            </div>
          </div>
          <!-- 聊天室  排行榜 -->
          <div class="" style="
              display: flex;
              align-items: center;
              justify-content: space-around;
              margin-top: 8px;
              cursor: pointer;
            ">
            <div :class="current == index ? 'active' : ''" v-for="(item, index) in tabLizt" :key="index" style=""
              @click="changTab(index)">
              {{ item }}
              <div :class="current == index ? 'active1' : ''" style="
                  width: 40px;
                  height: 2px;
                  background-color: #fff;
                  margin: 0 auto 4px;
                "></div>
            </div>
          </div>
          <div class="" style="
              border-bottom: 1px solid #eee;
              background-color: #ededed;
              padding: 10px;
              box-sizing: border-box;
              overflow-y: scroll;
              flex: 1;
            " ref="scrollBox" @scroll="handleScroll">
            <div class="" v-if="current == 0">
              <div class="" style="color: #777">
                <!-- <span style="color: #000">系统消息:</span> -->
                <!-- 官方将24小时巡查聊天室,禁止传播封建迷信,暴力血腥,招嫖诈骗,违禁品等不良信息!如有违反将封号处理!防丢失请记住备用域名 <a href="https://lingchuang.co"
                  style="text-decoration: underline;color: #0000ff;">https://lingchuang.co</a>或下载APP -->
                <div v-html="config.system_message"></div>

              </div>
              <div class="">
                <div class="" v-for="(item, index) in list" :key="index" style="display: flex; margin-top: 15px">
                  <div class="" style="
                      background-color: #4b72f6;
                      padding: 0 2px;
                      margin-right: 4px;
                      border-radius: 2px;
                      font-size: 12px;
                      height: 20px;
                      color: #fff;
                    ">
                    Hi
                  </div>
                  <!-- {{ item }} -->
                  <div class="" v-if="item.data.normal">
                    <div class=""
                      style="background-color: #bbb;padding: 0 2px;border-radius: 2px;color: #fff;margin-right: 4px;font-size: 12px;"
                      v-if="item.data.normal.level == 1">lv.{{ item.data.normal.level }}</div>
                    <div class=""
                      style="background-color: #5dd479;padding: 0 2px;border-radius: 2px;color: #fff;margin-right: 4px;font-size: 12px;"
                      v-else-if="item.data.normal.level == 2">lv.{{ item.data.normal.level }}</div>
                    <div class=""
                      style="background-color: #00c5b4;padding: 0 2px;border-radius: 2px;color: #fff;margin-right: 4px;font-size: 12px;"
                      v-else-if="item.data.normal.level == 3">lv.{{ item.data.normal.level }}</div>
                    <div class=""
                      style="background-color: #008da4;padding: 0 2px;border-radius: 2px;color: #fff;margin-right: 4px;font-size: 12px;"
                      v-else-if="item.data.normal.level == 4">lv.{{ item.data.normal.level }}</div>
                    <div class=""
                      style="background-color: #005b8c;padding: 0 2px;border-radius: 2px;color: #fff;margin-right: 4px;font-size: 12px;"
                      v-else>lv.{{ item.data.normal.level }}</div>
                  </div>

                  <div class="" v-if="item.data.level">
                    <div class=""
                      style="background-color: #bbb;padding: 0 2px;border-radius: 2px;color: #fff;margin-right: 4px;font-size: 12px;"
                      v-if="item.data.level == 1">lv.{{ item.data.level }}</div>
                    <div class=""
                      style="background-color: #5dd479;padding: 0 2px;border-radius: 2px;color: #fff;margin-right: 4px;font-size: 12px;"
                      v-else-if="item.data.level == 2">lv.{{ item.data.level }}</div>
                    <div class=""
                      style="background-color: #00c5b4;padding: 0 2px;border-radius: 2px;color: #fff;margin-right: 4px;font-size: 12px;"
                      v-else-if="item.data.level == 3">lv.{{ item.data.level }}</div>
                    <div class=""
                      style="background-color: #008da4;padding: 0 2px;border-radius: 2px;color: #fff;margin-right: 4px;font-size: 12px;"
                      v-else-if="item.data.level == 4">lv.{{ item.data.level }}</div>
                    <div class=""
                      style="background-color: #005b8c;padding: 0 2px;border-radius: 2px;color: #fff;margin-right: 4px;font-size: 12px;"
                      v-else>lv.{{ item.data.level }}</div>
                  </div>

                  <div class="" style="color: #777" v-if="item.type == 4">
                    {{ item.nick }}:
                    <span style="color: #333">赠送了一个{{ item.data.gift_name }}
                    </span>
                    <img :src="item.data.gift_image" alt="" style="width: 20px; height: 20px" />
                  </div>
                  <div class="" style="color: #777" v-if="item.type == 8">
                    {{ JSON.parse(item.payload.data).nick }}:
                    <span style="color: #333">赠送了一个{{ JSON.parse(item.payload.data).gift_name }}
                    </span>
                    <img :src="JSON.parse(item.payload.data).gift_image" alt="" style="width: 20px; height: 20px" />
                  </div>

                  <!-- <div class="" style="color: #777;" v-else>{{ item.nick }}: <span v-html="getText(item.data)"></span>
                  </div> -->
                  <div class="" style="color: #777" v-if="item.type == 1" @click="chooseMessage(item)">
                    {{ item.nick }}: <span v-html="getText(item.data)"></span>
                  </div>
                  <div class="" style="color: #777" v-if="item.type == 2" @click="chooseMessage(item)">
                    {{ item.nick }}:
                    <span v-html="getText(item.data.text)"></span>
                  </div>

                  <div class="" style="color: #777" v-if="item.type == 3" @click="chooseMessage(item)">
                    {{ item.nick }}:
                    <span>{{ item.data }}</span>
                  </div>



                  <div class="" style="color: #777" v-if="item.type == 7" @click="chooseMessage(item)">
                    {{ JSON.parse(item.payload.data).normal.nick }}:
                    <span v-html="getText(JSON.parse(item.payload.data).normal.text)
                      "></span>
                    <!-- <span>{{ JSON.parse(item.payload.data).normal.text}}</span> -->
                  </div>
                  <div class="" style="color: #777" v-if="item.type == 'TIMCustomElem'" @click="chooseMessage(item)">
                    {{ item.data.normal.nick }}:
                    <span>{{ item.data.normal.text }}</span>
                  </div>

                </div>

              </div>
            </div>
            <div class="" v-if="current == 1">
              <div class="" v-for="(item, index) in paihangList" :key="index" style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 20px;
                ">
                <div class="" style="display: flex; align-items: center">
                  <div class="" style="
                      width: 16px;
                      height: 16px;
                      border-radius: 50%;
                      background-color: #ffb600;
                      text-align: center;
                      line-height: 16px;
                      margin-right: 10px;
                      font-size: 12px;
                    " v-if="index == 0">
                    {{ index + 1 }}
                  </div>
                  <div class="" style="
                      width: 16px;
                      height: 16px;
                      border-radius: 50%;
                      background-color: #c8cbcf;
                      text-align: center;
                      line-height: 16px;
                      margin-right: 10px;
                      font-size: 12px;
                    " v-else-if="index == 1">
                    {{ index + 1 }}
                  </div>
                  <div class="" style="
                      width: 16px;
                      height: 16px;
                      border-radius: 50%;
                      background-color: #ebb68a;
                      text-align: center;
                      line-height: 16px;
                      margin-right: 10px;
                      font-size: 12px;
                    " v-else-if="index == 2">
                    {{ index + 1 }}
                  </div>
                  <div class="" style="
                      width: 16px;
                      height: 16px;
                      text-align: center;
                      line-height: 16px;
                      margin-right: 10px;
                      font-size: 12px;
                    " v-else>
                    {{ index }}
                  </div>
                  <img :src="baseUrl + item.user.avatar" alt="" style="
                      width: 40px;
                      height: 40px;
                      border-radius: 50%;
                      display: block;
                      margin-right: 6px;
                    " />
                  <div class="text-ellipsis" style="margin-right: 6px; width: 100px">
                    {{ item.user.nickname }}
                  </div>
                  <div class="" style="
                      background-color: #bbb;
                      padding: 0 2px;
                      border-radius: 2px;
                      color: #fff;
                      margin-right: 2px;
                      font-size: 10px;
                    " v-if="item.user.level == 1">
                    lv.{{ item.user.level }}
                  </div>
                  <div class="" style="
                      background-color: #5dd479;
                      padding: 0 2px;
                      border-radius: 2px;
                      color: #fff;
                      margin-right: 2px;
                      font-size: 10px;
                    " v-else-if="item.user.level == 2">
                    lv.{{ item.user.level }}
                  </div>
                  <div class="" style="
                      background-color: #00c5b4;
                      padding: 0 2px;
                      border-radius: 2px;
                      color: #fff;
                      margin-right: 2px;
                      font-size: 10px;
                    " v-else-if="item.user.level == 3">
                    lv.{{ item.user.level }}
                  </div>
                  <div class="" style="
                      background-color: #008da4;
                      padding: 0 2px;
                      border-radius: 2px;
                      color: #fff;
                      margin-right: 2px;
                      font-size: 10px;
                    " v-else-if="item.user.level == 4">
                    lv.{{ item.user.level }}
                  </div>
                  <div class="" style="
                      background-color: #005b8c;
                      padding: 0 2px;
                      border-radius: 2px;
                      color: #fff;
                      margin-right: 2px;
                      font-size: 10px;
                    " v-else>
                    lv.5
                  </div>
                </div>
                <div class="" style="color: #666; font-size: 12px">
                  贡献{{ item.heat }}
                </div>
              </div>
            </div>
            <div class="" v-if="current == 2">
              <div class="" v-for="(item, index) in vistorList" :key="index" style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 20px;
                ">
                <div class="" style="display: flex; align-items: center">
                  <div class="" style="
                      width: 16px;
                      height: 16px;
                      border-radius: 50%;
                      background-color: #ffb600;
                      text-align: center;
                      line-height: 16px;
                      margin-right: 10px;
                      font-size: 12px;
                    " v-if="index == 0">
                    {{ index + 1 }}
                  </div>
                  <div class="" style="
                      width: 16px;
                      height: 16px;
                      border-radius: 50%;
                      background-color: #c8cbcf;
                      text-align: center;
                      line-height: 16px;
                      margin-right: 10px;
                      font-size: 12px;
                    " v-else-if="index == 1">
                    {{ index + 1 }}
                  </div>
                  <div class="" style="
                      width: 16px;
                      height: 16px;
                      border-radius: 50%;
                      background-color: #ebb68a;
                      text-align: center;
                      line-height: 16px;
                      margin-right: 10px;
                      font-size: 12px;
                    " v-else-if="index == 2">
                    {{ index + 1 }}
                  </div>
                  <div class="" style="
                      width: 16px;
                      height: 16px;
                      text-align: center;
                      line-height: 16px;
                      margin-right: 10px;
                      font-size: 12px;
                    " v-else>
                    {{ index }}
                  </div>
                  <img :src="baseUrl + item.avatar" alt="" style="
                      width: 40px;
                      height: 40px;
                      border-radius: 50%;
                      display: block;
                      margin-right: 6px;
                    " />
                  <div class="text-ellipsis" style="margin-right: 6px; width: 100px">
                    {{ item.nickname }}
                  </div>
                </div>
                <div class="" v-if="userInfo.group_id == 2">
                  <!-- <div class="" style="background-color: #4b72f6;color: #fff;padding: 0 5px;"
                    @click="jinyan(item.user.id)" v-if="item.user.speech_auth == 1">
                    禁言
                  </div> -->
                  <div class="" style="background-color: #4b72f6;color: #fff;padding: 0 5px;"
                    @click="jcjinyan(item.id)">
                    解除禁言
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="" style="height: 100px; padding: 10px; box-sizing: border-box">
            <div class="" style="display: flex; align-items: center">
              <div class="input-emoji">
                <div class="common-emoji">
                  <el-popover placement="top" width="300" trigger="click">
                    <ul class="emoji-mart-category-list">
                      <li v-for="(item, index) in emotion" @click="setEmotion(item.emojiName)" :key="index">
                        <img class="emoji-mart-emoji emoji-mart-emoji-native" style="width: 30px; height: 30px"
                          :src="item.url" />
                      </li>
                    </ul>
                    <div slot="reference">
                      <img src="../assets/images/emoji.png" alt=""
                        style="width: 16px; height: 16px; margin-right: 20px" />
                    </div>
                  </el-popover>
                </div>
              </div>
              <div class="input-emoji">
                <div class="common-emoji">
                  <el-popover placement="top" width="100" trigger="click">
                    <!-- <div class="" style="">
                      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                        @change="handleCheckAllChange">全选</el-checkbox>
                      <div ></div>
                      <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                        <el-checkbox v-for="city in cities" :label="city" :key="city">{{ city }}</el-checkbox>
                      </el-checkbox-group>
                    </div> -->
                    <div class="">
                      <div class="" style="display: flex;align-items: center;" @click="chooseAll">
                        <div class=""
                          style="width: 15px;height: 15px;border-radius: 50%;margin-right: 5px;background-color: #4b72f6;"
                          v-if="checkAll">
                        </div>
                        <div class=""
                          style="width: 15px;height: 15px;border-radius: 50%;border: 1px solid #999;margin-right: 5px;"
                          v-else>
                        </div>
                        <div class=""> 全选</div>
                      </div>
                      <div class="" style="display: flex;align-items: center;" @click="chooseOne">
                        <div class=""
                          style="width: 15px;height: 15px;border-radius: 50%;margin-right: 5px;background-color: #4b72f6;"
                          v-if="checkOne">
                        </div>
                        <div class=""
                          style="width: 15px;height: 15px;border-radius: 50%;border: 1px solid #999;margin-right: 5px;"
                          v-else>
                        </div>
                        <div class="">屏蔽礼物动画</div>
                      </div>
                      <div class="" style="display: flex;align-items: center;" @click="chooseTwo">
                        <div class=""
                          style="width: 15px;height: 15px;border-radius: 50%;margin-right: 5px;background-color: #4b72f6;"
                          v-if="checkTwo">
                        </div>
                        <div class=""
                          style="width: 15px;height: 15px;border-radius: 50%;border: 1px solid #999;margin-right: 5px;"
                          v-else>
                        </div>
                        <div class=""> 屏蔽进场欢迎</div>
                      </div>


                    </div>
                    <div slot="reference">
                      <img src="../assets/images/icon-danmu-gray@2x.png" alt=""
                        style="width: 16px; height: 16px; margin-right: 20px" />
                    </div>
                  </el-popover>
                </div>
              </div>
              <div class="" style="background-color: #4b72f6;color: #fff;padding: 0 10px;" @click="jinyan"
                v-if="userInfo.group_id == 2 && showjinyan">
                禁言
              </div>
            </div>

            <div class="" style="
                height: 52px;
                margin-top: 10px;
                display: flex;
                align-items: center;
              ">
              <div class="" style="
                  height: 52px;
                  border: 1px solid #eee;
                  border-radius: 2px 0 0 2px;
                  box-sizing: border-box;
                  flex: 1;
                " v-if="userInfo.id">
                <input v-model="message" placeholder="请输入内容" @keyup.enter="sendMessage" style="
                    height: 52px;
                    border: none;
                    border-radius: 2px 0 0 2px;
                    box-sizing: border-box;
                    border: none;
                    width: 200px;
                  " />
              </div>
              <div class="" style="
                  height: 52px;
                  border: 1px solid #eee;
                  border-radius: 2px 0 0 2px;
                  box-sizing: border-box;
                  flex: 1;
                " v-else>
                <div class="" style="display: flex; align-items: center; padding: 5px">
                  <div class="" style="color: #4b72f6; margin-right: 3px; color: #4b72f6;" @click="login">
                    登录
                  </div>
                  <div class="" style="color: #777">后才可以发送消息哦~~</div>
                </div>
              </div>

              <div :class="userInfo.id ? 'isLogin' : ''" style="
                  background-color: #e5e5e5;
                   color: #fff;
                  height: 52px;
                  border-radius: 0 2px 2px 0;
                  text-align: center;
                  line-height: 52px;
                  width: 60px;
                " @click="sendMessage">
                发送
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="" style="width: 1200px; margin: 20px auto">
      <div class="" style="margin-bottom: 20px; font-size: 24px">主播日程</div>
      <!-- 轮播图 -->
      <div class="" style="position: relative; height: 130px">
        <div class="" style="position: absolute; left: -60px; top: 50px" @click="leftSlide">
          <i class="el-icon-arrow-left" style="margin: 0 10px; font-size: 40px"></i>
        </div>
        <!-- <div style="
            background-color: #fff;
            border: 1px solid #eee;
            border-right: none;
            border-radius: 4px;
            overflow-x: scroll;
            display: flex;
            height: 130px;
          " class="scroll_wrapper1" ref="wrapperCon">
          <div class="" v-for="(item, index) in couseList" :key="index" style="
              border-right: 1px solid #eee;
              padding: 16px;
              box-sizing: border-box;
              flex-shrink: 0;
              width: 240px;
              height: 130px;
            ">
            <div class="" style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              ">
              <div class="" style="
                  display: flex;
                  align-items: center;
                  color: #777;
                  font-size: 12px;
                ">
                <img src="../assets/images/f-0.png" alt="" style="width: 12px; height: 12px; margin-right: 4px" />
                <div class=""
                  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;width: 100px;font-size: 14px;">
                  {{ item.match.league_name }}

                </div>
              </div>
              <div class="" style="color: #777;font-size: 14px;">
                {{ item.match.match_time.substring(5, 16) }}
              </div>
            </div>
            <div class="" style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 20px;
              ">
              <div class="">
                <div class="" style="display: flex; align-items: center">
                  <img :src="item.match.home_team_logo_text" alt=""
                    style="width: 24px; height: 24px; margin-right: 4px" />
                  <div class="" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;width: 100px;">
                    {{ item.match.home_team_name }}
                  </div>
                </div>
                <div class="" style="display: flex; align-items: center; margin-top: 10px">
                  <img :src="item.match.away_team_logo_text" alt=""
                    style="width: 24px; height: 24px; margin-right: 4px" />
                  <div class="" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;width: 100px;">
                    {{ item.match.away_team_name }}
                  </div>
                </div>
              </div>
              <div class="" style="text-align: right; font-size: 18px" v-if="item.match.live_status == 1">
                直播中...
              </div>
              <div class="" v-if="item.match.live_status == 0">
                <div class=""
                  style="color: #fff !important;background-color: #4b72f6;width: 52px;height: 25px;font-size: 12px;border-radius: 4px;text-align: center;line-height: 25px;"
                  v-if="!item.is_reservation" @click="goyuyue(item, 1)">
                  预约
                </div>
                <div class=""
                  style="color: #fff !important;background-color: #e5e5e5;width: 52px;height: 25px;font-size: 12px;border-radius: 4px;text-align: center;line-height: 25px;"
                  v-if="item.is_reservation" @click="goyuyue(item, 0)">
                  已预约
                </div>
              </div>
              <div class="" style="text-align: right; font-size: 18px" v-if="item.match.live_status == 2">
                已结束
              </div>
            </div>
          </div>
        </div> -->

        <div class="" style="width: 1200px;overflow: hidden;position: relative;height: 130px;background-color: #fff;">
          <div :style="{ left: left + 'px' }" class="gundongBox">
            <div class="" v-for="(item, index) in couseList" :key="index" style="
              border-right: 1px solid #eee;
              padding: 16px;
              box-sizing: border-box;
              flex-shrink: 0;
              width: 240px;
              height: 130px;
            ">
              <div class="" style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              ">
                <div class="" style="
                  display: flex;
                  align-items: center;
                  color: #777;
                  font-size: 12px;
                ">
                  <img src="../assets/images/f-0.png" alt="" style="width: 12px; height: 12px; margin-right: 4px" />
                  <div class=""
                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;width: 100px;font-size: 14px;">
                    {{ item.match.league_name }}

                  </div>
                </div>
                <div class="" style="color: #777;font-size: 14px;">
                  {{ item.match.match_time.substring(5, 16) }}
                </div>
              </div>
              <div class="" style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 20px;
              ">
                <div class="">
                  <div class="" style="display: flex; align-items: center">
                    <img :src="item.match.home_team_logo_text" alt=""
                      style="width: 24px; height: 24px; margin-right: 4px" />
                    <div class="" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;width: 100px;">
                      {{ item.match.home_team_name }}
                    </div>
                  </div>
                  <div class="" style="display: flex; align-items: center; margin-top: 10px">
                    <img :src="item.match.away_team_logo_text" alt=""
                      style="width: 24px; height: 24px; margin-right: 4px" />
                    <div class="" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;width: 100px;">
                      {{ item.match.away_team_name }}
                    </div>
                  </div>
                </div>
                <div class="" style="text-align: right; font-size: 18px" v-if="item.match.live_status == 1">
                  直播中...
                </div>
                <div class="" v-if="item.match.live_status == 0">
                  <div class=""
                    style="color: #fff !important;background-color: #4b72f6;width: 52px;height: 25px;font-size: 12px;border-radius: 4px;text-align: center;line-height: 25px;"
                    v-if="!item.is_reservation" @click="goyuyue(item, 1)">
                    预约
                  </div>
                  <div class=""
                    style="color: #fff !important;background-color: #e5e5e5;width: 52px;height: 25px;font-size: 12px;border-radius: 4px;text-align: center;line-height: 25px;"
                    v-if="item.is_reservation" @click="goyuyue(item, 0)">
                    已预约
                  </div>
                </div>
                <div class="" style="text-align: right; font-size: 18px" v-if="item.match.live_status == 2">
                  已结束
                </div>
              </div>
            </div>



          </div>
        </div>


        <div class="" style="position: absolute; right: -60px; top: 50px" @click="rightSlide">
          <i class="el-icon-arrow-right" style="margin: 0 10px; font-size: 40px"></i>
        </div>
      </div>
      <!-- 推荐视频 -->
      <div class="" style="margin-bottom: 10px; margin-top: 20px; font-size: 24px">
        视频推荐
      </div>
      <!-- <myList1 :list="list1"></myList1> -->
      <div class="goodsBox" style="display: flex; align-items: center; flex-wrap: wrap">
        <div class="" v-for="(item, index) in list1" :key="index"
          style="width: 226px; margin-right: 17px; margin-bottom: 30px" @mouseenter="current1 = item"
          @mouseleave="current1 = 0" @click="choose(item)">
          <div class="" style="
              width: 226px;
              border-radius: 6px 6px 0 0;
              height: 127px;
              display: block;
              position: relative;
            ">
            <img :src="baseUrl + item.cover_image" alt="" style="
                width: 226px;
                border-radius: 6px 6px 0 0;
                height: 127px;
                display: block;
              " />
            <div class="" style="
                background-color: #fa3434;
                color: #fff;
                position: absolute;
                top: 10px;
                right: 10px;
                padding: 0 4px;
                font-size: 12px;
              ">
              <img src="../assets/images/live.gif" alt="" style="height: 10px; width: 10px" />
              Live
            </div>
            <img src="../assets/imgs/play.png" alt="" style="
                height: 60px;
                width: 60px;
                position: absolute;
                top: 33px;
                left: 83px;
              " v-if="current1 == item" />
            <div class="" style="
                position: absolute;
                top: 10px;
                left: 0;
                background-color: #218aff;
                color: #fff;
                padding: 0 3px;
              ">
              推荐
            </div>
          </div>
          <div class="" style="
              background-color: #fff;
              padding: 10px;
              border-radius: 0 0 6px 6px;
            ">
            <div class="text-ellipsis" style="">
              {{ item.title }}
            </div>
            <div class="" style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 5px;
              ">
              <div class="" style="
                  display: flex;
                  align-items: center;
                  font-size: 9px;
                  color: #777;
                  font-size: 12px;
                ">
                <img :src="baseUrl + item.user.avatar" alt="" style="
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    margin-right: 4px;
                  " />
                {{ item.user.nickname }}
              </div>
              <div class="" style="
                  display: flex;
                  align-items: center;
                  color: #777;
                  font-size: 12px;
                ">
                <img src="../assets/images/fire.png" alt="" style="width: 12px; height: 12px; margin-right: 2px" />
                {{ item.heat }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="" width="400px" center :visible.sync="digShow">
      <div class="" style="
          font-weight: bold;
          font-size: 18px;
          margin-top: 10px;
          margin-bottom: 20px;
        ">
        如何获取金币?
      </div>
      <div class="" style="display: flex; align-items: center">
        <img src="../assets/images/score-tip1.png" alt="" style="width: 50px; height: 50px; display: block" />
        <div class="">
          <div class="" style="font-weight: bold">登录获得金币</div>
          <div class="" style="font-size: 12px">
            每日登录可获取金币,连续登录天数越长,金币越多
          </div>
        </div>
      </div>
      <div class="" style="display: flex; align-items: center; margin-top: 20px">
        <img src="../assets/images/score-tip2.png" alt="" style="width: 50px; height: 50px; display: block" />
        <div class="">
          <div class="" style="font-weight: bold">观看直播获得金币</div>
          <div class="" style="font-size: 12px">
            每观看十分钟直播,可以获取5点金币
          </div>
        </div>
      </div>
    </el-dialog>





  </div>
</template>
<script>
import { mapActions } from "vuex";

import NavTop from "../components/NavTopWhit.vue";
import myList1 from "../components/MyList1.vue";
import liveTv from "../views/live-tv.vue";
import svgaplayer from '../components/svgaPlayer.vue'
const cityOptions = ['屏蔽礼物动画', '屏蔽进场欢迎'];
import {
  getliveMacthList,
  getLiveDetail,
  getLivelist,
  getsaichenglist,
  getHistoryByRoomId,
  follow,
  unfollow,
  gifiList,
  sendGift,
  getUserInfo,
  rankList,
  getMOney,
  setJinyan,
  getConfreservationig,
  getConfig,
  getVistor,
  hotLive
} from "../api/user";
import TencentCloudChat from "@tencentcloud/chat";
import { emojiName, emojiUrl, emojiMap } from "./emojiMap";
import emotion from "./persona/emotion.json";

import store from "@/store/index.js";
var timer = null
export default {
  components: {
    svgaplayer,
    NavTop,
    liveTv,
  },
  data() {
    return {
      aotoPl: true,
      checkAll: false,
      checkOne: false,
      checkTwo: false,
      checkedCities: ['上海', '北京'],
      cities: cityOptions,
      isIndeterminate: true,
      paihangList: [],
      showgist: -1,
      showTips: false,
      showTips1: false,
      tabLizt: ["聊天室", "排行榜"],
      list1: [], //全部
      current: 0,
      current1: 0,
      digShow: false,
      detail: {
        away_logo: "",
        away_name: "",
        clarity: {},
        clicktime: 1747287486,
        deletetime: 0,
        home_logo: "",
        home_name: "",
        hotvotes: 0,
        id: 200,
        is_home: 0,
        is_live: 0,
        ishot: 0,
        islive: 1,
        isliveName: "Live",
        isrecommend: 0,
        live_duration: "",
        match_id: 0,
        match_time: "",

        pull: "",
        push: "",
        starttime: 0,
        stream: "",
        thumb: "",
        title: "【BAT】CHEUN / CHOI vs KUSUM / PRATI",
        type: 2,
        typeName: "Lain",
        uid: 174,
        viewers: 1011,
        user: {
          avatar: ''
        }
      },
      reserve: {},
      userData: "",
      basketball: "",
      heat: "",
      id: "",
      couseList: [],
      userInfo: {},
      message: "",
      roomid: "",
      userID: "",
      userSign: "",
      liveDEtail: {},
      emotion: [],
      gifList: [],
      watchSecond: 0, //观看直播时长
      showGift: false,
      svgSrc: '',
      config: {},
      vistorList: [],
      showjinyan: false,
      jinyanID: 0,
      timestamp: 0,
      left: 0,
      huadongLength: 0,
      huadongCurrent: 0
    };
  },
  beforeDestroy() {
    this.detail.pull = "";
    console.log("记录的时间", this.watchSecond);
    let timeMinute = (this.watchSecond / 60).toFixed(0);
    if (timeMinute > 10) {
      this.addMOney(timeMinute);
    }
    clearInterval(timer)

  },
  created() {
    window.scrollTo(0, 0);
    this.id = this.$route.query.id
    this.anchorId = this.$route.query.userId
    this.getDetail();
    this.getList(); //直播列表

    this.getGift(); //礼物列表
    this.getranklist(); //排行榜
    this.watchSecond = 0;
    this.getconfig()




  },

  beforeMount() {
    for (let i = 0; i < emojiName.length; i++) {
      this.emotion.push({
        emojiName: emojiName[i],
        url: emojiUrl + emojiMap[emojiName[i]],
      });
    }


  },
  mounted() {
    this.userinfo(); //用户信息

    timer = setInterval(() => {
      this.watchSecond++;
      this.getDetail123();

    }, 5000);

  },
  computed: {
    info() {
      return this.$store.state.user;
    },
    infos() {
      return this.$store.state.infos;
    },
    list() {
      var messageList = JSON.parse(
        JSON.stringify(this.$store.state.messageList)
      );
      return messageList;
    },
    system() {
      return this.$store.state.system;
    },
  },
  watch: {
    list(e) {
      console.log('消息改变了就滚动', e);
      setTimeout(() => {
        this.scrollToBottom(50)

      }, 50);
    },
  },
  methods: {
    ...mapActions([
      "setUser",
      "setShowLogin",
      "setShoppingCart",
      "setShowRegister",
    ]),
    login() {
      // 点击登录按钮, 通过更改vuex的showLogin值显示登录组件
      this.setShowLogin(true);
    },
    chooseMessage(item) {
      console.log('选择的消息', JSON.parse(item.payload.data).normal.user_id);

      this.jinyanID = JSON.parse(item.payload.data).normal.user_id
      if (this.jinyanID == this.userInfo.id) {
        return
      } else {
        this.showjinyan = !this.showjinyan

      }


    },
    handleScroll(event) {
      console.log('当前滚动位置:', event.target.scrollTop)
      // 可以在这里添加滚动监听逻辑
    },
    // 滚动到底部
    scrollToBottom(number) {
      const scrollBox = this.$refs.scrollBox
      console.log('当前滚动位置4484684:', scrollBox.scrollHeight)

      scrollBox.scrollTop = scrollBox.scrollHeight + number

      console.log('当前滚动位置4484684:', scrollBox.scrollTop)

    },
    getvistorList() {
      getVistor().then((res) => {
        this.vistorList = res.data
      });
    },
    changTab(index) {
      this.current = index
      if (index == 2) {
        this.getvistorList()
      }
    },
    getconfig() {
      getConfig().then((res) => {
        this.config = res.data;
        console.log('废话无法会务费', res.data);
      });
    },
    goyuyue(item, type) {
      getConfreservationig({
        id: item.match_id,
        type
      }).then((res) => {
        // if (res.code == 1) {
        //   item.hasLive=1
        // }
        // this.getList();
        if (type == 1) {
          // 关注
          item.is_reservation = true
        } else {
          // 取关
          item.is_reservation = false
        }
      });
    },
    jinyan() {
      setJinyan({
        user_id: this.jinyanID,
        speech_auth: 0
      }).then(res => {
        this.notifySucceed("禁言成功");
        this.showjinyan = false
      })

    },
    jcjinyan(id) {
      setJinyan({
        user_id: id,
        speech_auth: 1
      }).then(res => {
        this.notifySucceed("解除禁言成功");
        this.getvistorList()
      })
    },
    chooseAll() {
      if (this.checkAll) {
        this.checkAll = false
        this.checkOne = false
        this.checkTwo = false
      } else {
        this.checkAll = true
        this.checkOne = true
        this.checkTwo = true
      }

    },
    chooseOne() {
      if (this.checkTwo && this.checkOne) {
        this.checkAll = false
      } else if (this.checkTwo && !this.checkOne) {
        this.checkAll = true
      }
      this.checkOne = !this.checkOne


    },
    chooseTwo() {
      if (this.checkOne && this.checkTwo) {
        this.checkAll = false
      } else if (this.checkOne && !this.checkTwo) {
        this.checkAll = true
      }
      this.checkTwo = !this.checkTwo


    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    addMOney(time) {
      getMOney({ watchTime: time }).then((res) => { });
    },
    setEmotion(item) {
      this.message = this.message + item;
    },
    userinfo() {
      getUserInfo().then((res) => {
        this.userInfo = res.data;
        if (this.userInfo.group_id == 2) {
          this.tabLizt = ["聊天室", "排行榜", '已禁言人员']
        } else {
          this.tabLizt = ["聊天室", "排行榜"]

        }
        setTimeout(() => {
          this.sendMessage1()

        }, 1000);
      });
    },
    userinfo1() {
      getUserInfo().then((res) => {
        this.userInfo = res.data;
      });
    },
    getText(str) {
      if (str.includes("[")) {
        let exp = /\[(.*?)\]/g; //匹配[*] 大括号里面任意内容的正则
        let arr = str.match(exp); //字符串匹配出来的数组
        if (!arr) return str;
        this.emotion.forEach((item1, index) => {
          arr.map((item) => {
            if (item1.emojiName === item) {
              str = str.replace(
                item,
                `<img src='${item1.url}' style="width:20px;height:20px">`
              );
            }
          }); //循环遍历
        });
        return str;
      } else {
        return str;
      }
    },
    getranklist() {
      rankList({
        live_id: this.id,
      }).then((res) => {
        if (res.code == 1) {
          this.paihangList = res.data;
        }
      });
    },
    songli(item) {
      this.svgSrc = item.animation_text
      sendGift({
        gift_id: item.id,
        live_id: this.id,
        user_id: this.userInfo.id,
        level: this.userInfo.level,
        quantity: 1
      }).then((res) => {
        if (res.code == 1) {
          this.notifySucceed("赠送成功");
          this.getranklist();
          // this.getHistory();
          this.userinfo1()
          if (!this.checkOne) {
            this.showGift = true
            setTimeout(() => {
              this.showGift = false
            }, 3000);
          }

        } else {
          this.notifyError(res.msg);
        }
      });
    },
    getGift() {
      gifiList().then((res) => {
        this.gifList = res.data;
      });
    },
    choose(item) {

      //   this.id = item.id
      //   // this.getDetail();

      this.$router.push({
        path: '/details',
        query: {
          id: item.id
        }
      })
      this.$router.go(0); // 刷新当前页面

    },
    changRoom(item) {
    
      this.$router.push({
        path: '/details',
        query: {
          id: item.id
        }
      })
      this.$router.go(0); // 刷新当前页面
    },
    qxgaunhzu() {
      unfollow({ id: this.liveDEtail.user_id, type: 0 }).then((res) => {
        if (res.code == 1) {
          this.liveDEtail.is_follow = 1;
          this.getDetail123();
        }
      });
    },
    gaunhzu() {
      follow({ id: this.liveDEtail.user_id, type: 1 }).then((res) => {
        if (res.code == 1) {
          this.liveDEtail.is_follow = 0;
          this.getDetail123();
        }
      });
    },
    getHistory() {
      let _this = this;
      getHistoryByRoomId({
        group_id: this.anchorId,
      }).then((res) => {
        if (!res.data) return;
        var arr = Object.values(res.data);
        arr = arr.sort((a, b) => a.MsgSeq - b.MsgSeq);
        var data = [];
        arr.forEach((item) => {
          if (item.content[0].MsgContent.Text) {
            data.push({
              nick: item.From_Account.nickname,
              type: "1",
              data: JSON.parse(item.content[0].MsgContent.Text),
            });
          } else if (JSON.parse(item.content[0].MsgContent.Data).normal) {
            // 文字消息
            data.push({
              nick: item.From_Account.nickname,
              type: "2",
              data: JSON.parse(item.content[0].MsgContent.Data).normal,
            });
          } else if (JSON.parse(item.content[0].MsgContent.Data).gift_name) {
            data.push({
              nick: item.From_Account.nickname,
              type: "4",
              data: JSON.parse(item.content[0].MsgContent.Data),
            });
          } else if (item.content[0].MsgContent.Data) {
            data.push({
              nick: item.From_Account.nickname,
              type: "3",
              data: JSON.parse(item.content[0].MsgContent.Data),
            });
          }
        });
        store.commit("updateMessageList", JSON.parse(JSON.stringify(data)));
      });
    },
    getscList() {
      let today = new Date();
      let obj = {};
      obj = {
        time: today.toISOString().slice(0, 10),
      };
      getliveMacthList({ page: 1, limit: 999, live_id: this.id }).then((res) => {
        this.couseList = res.data.data

        this.reserve = res.data.data[0]

      });
    },
    getList() {
      this.loading = true;
      getLivelist().then((res) => {
        this.loading = false;
        this.list1 = res.data.data
      });
    },
    sendMessage1() {
      let _this = this;
      let msg = {
        type: 105,
        normal: {
          text: this.userInfo.nickname + '进入了直播间',
          is_room: 0,
          nick: this.userInfo.nickname,
          user_id: this.userInfo.id,
          level: this.userInfo.level,
        },
      };
      let options = {
        to: this.roomid,
        conversationType: this.TIM.TYPES.CONV_GROUP,
        payload: {
          data: JSON.stringify(msg),
        },
      };
      let messageTex = this.tim.createCustomMessage(options);
      let promise = this.tim.sendMessage(messageTex);
      promise
        .then(function (imResponse) {
          _this.message = "";
          // _this.getHistory();
        })
        .catch(function (imError) {
          // Pengiriman pesan gagal
          _this.$message.error(imError);
        });
    },
    //  发送消息
    sendMessage() {

      const timestamp = new Date().getTime();

      if (this.timestamp) {
        if (timestamp - this.timestamp > 1000) {
          console.log('可以发送');

        } else {
          console.log('间隔时间太短');
          return

        }
      } else {
        this.timestamp = timestamp
      }




      let _this = this;
      if (!this.message.trim()) {
        return this.$message.warning("请输入内容后发送");
      }
      this.message = this.message.replace(/逼/g, "*")
      this.message = this.message.replace(/妈/g, "*")
      this.message = this.message.replace(/爸/g, "*")
      this.message = this.message.replace(/爹/g, "*")
      this.message = this.message.replace(/中国/g, "**")
      this.message = this.message.replace(/国家/g, "**")
      this.message = this.message.replace(/政府/g, "**")
      this.message = this.message.replace(/传销/g, "**")
      this.message = this.message.replace(/色情/g, "**")
      this.message = this.message.replace(/性/g, "*")
      this.message = this.message.replace(/赌/g, "*")
      this.message = this.message.replace(/黄/g, "*")
      this.message = this.message.replace(/毒/g, "*")
      this.message = this.message.replace(/死/g, "*")
      this.message = this.message.replace(/全家/g, "**")

      if (this.message.indexOf('http') != -1 || this.message.indexOf('.com') != -1 || this.message.indexOf('.cn') != -1) {
        return this.$message.warning("内容有敏感词,不可发送");
      }

      var reg = /^\d+$/;
      var reg1 = /^\w+$/
      if (reg.test(this.message.trim()) || reg1.test(this.message.trim())) {
        return this.$message.warning("内容有敏感词,不可发送");
      }
      getUserInfo().then((res) => {
        if (res.data.speech_auth != 1) {
          return this.$message.warning("你已被禁言");
        } else {
          let msg = {
            type: 105,
            normal: {
              text: this.message,
              is_room: 0,
              nick: this.userInfo.nickname,
              user_id: this.userInfo.id,
              level: this.userInfo.level,
              group_id: this.userInfo.group_id,
            },
          };
          let options = {
            to: this.roomid,
            conversationType: this.TIM.TYPES.CONV_GROUP,
            payload: {
              data: JSON.stringify(msg),
            },
          };
          _this.message = "";
          let messageTex = this.tim.createCustomMessage(options);
          let promise = this.tim.sendMessage(messageTex);

          promise
            .then(function (imResponse) {
              // _this.$refs.livetv.addDam(_this.message)
              console.log("发送成功gerg:", _this.message);
              // _this.getHistory();
              _this.scrollToBottom(0)

            })
            .catch(function (imError) {
              // Pengiriman pesan gagal
              _this.$message.error(imError);
              console.warn("发送失败:", imError);
            });



        }

      }).catch(err => {

        this.$router.go(0); // 刷新当前页面

      })


    },
    getDetail() {
      getLiveDetail({
        id: this.id,
        anchor_id: this.anchorId

      }).then((res) => {
        if (res.code == 1) {
          this.detail.pull = res.data.pull;
          this.roomid = String(res.data.user_id);
          this.liveDEtail = res.data;
          this.id = res.data.id
          this.anchorId = res.data.user_id
          // this.getHistory();
          this.getscList(); //赛程列表
          setTimeout((res) => {
            this.$store.dispatch("joinGroup", {
              id: this.roomid,
            });

          }, 1000);

        } else {
          this.detail.islive = 0
          this.liveDEtail = this.detail

        }

      });
    },
    getDetail123() {
      getLiveDetail({
        id: this.id,
        anchor_id: this.anchorId
      }).then((res) => {
        if (res.code == 1) {
          this.liveDEtail = res.data;
          this.id = res.data.id
          this.anchorId = res.data.user_id
        } else {
          this.detail.islive = 0
          this.liveDEtail = this.detail

        }

      });
    },
    // 左箭头
    leftSlide() {
      // 保存滚动盒子左侧已滚动的距离
      if (this.huadongCurrent == 0) {
        console.log('是第一个');

      } else {
        this.left += 240
        this.huadongCurrent -= 1
      }
    },
    // 右箭头
    rightSlide() {
      if (this.huadongLength - this.huadongCurrent > 5) {
        this.left -= 240
        this.huadongCurrent += 1
      } else {

        return
      }
    },
  },
};
</script>

<style scoped>
.active {
  font-weight: bold;
  font-size: 15px;
}

.active1 {
  background-color: #4b72f6 !important;
}

/*隐藏滚动条*/
.scroll_wrapper1::-webkit-scrollbar {
  display: none;
}

.goodsBox div:nth-child(5n) {
  margin-right: 0 !important;
}

.notice-box {
  width: 175px;
  color: #333;
  background: #ffffff;
  box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  box-sizing: border-box;
  position: absolute;
  right: -80px;
  padding-bottom: 30px;
  top: 25px;
}

.notice-box .notice-title {
  text-align: center;
}

.notice-box .line {
  width: 196px;
  height: 1px;
  border-bottom: 1px solid #e6e6e6;
  margin-top: 20px;
}

.notice-box .notice-item {
  margin-top: 20px;
}

.notice-box .seemore a {
  text-align: center;
  color: #4b72f6;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.gogngaoBox:hover {
  height: 150px !important;
}

.isLogin {
  background-color: #4b72f6 !important;
}

input:focus {
  outline: none;
  border: none !important;
  box-shadow: 0 0 0 2px transparent;
}

.emoji-mart-category-list {
  margin: 0;
  padding: 0;
}

.emoji-mart-category-list li {
  list-style: none;
  margin: 0;
  padding: 0;
  display: inline-block;
}

.emoji-mart-emoji {
  position: relative;
  display: inline-block;
  font-size: 0;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  box-shadow: none;
}

.emoji-mart-emoji-native {
  font-family: Segoe UI Emoji, Segoe UI Symbol, Segoe UI, Apple Color Emoji,
    Twemoji Mozilla, Noto Color Emoji, Android Emoji;
}

.gundongBox {


  background-color: #fff;
  border: 1px solid #eee;
  border-right: none;
  border-radius: 4px;
  display: flex;
  height: 130px;
  position: absolute;



}
</style>
